import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import FooterLogo from "../../assets/images/logo.svg";

import { Container } from "@mui/material";

const Footer = () => {
  return (
    <>
      <div className="copyright-footer">
        <h6>Copyright © 2025 Wehad Bot. All Rights Reserved</h6>
       <div className="d-flex gap-3 justify-content-center">
       <Link>Terms & Condition </Link><Link>Privacy Policy</Link>
       </div>
      </div>
    </>
  );
};

export default Footer;
